export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            联系我们
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            欢迎合作、投稿或提出宝贵建议
          </p>
          <div className="mt-8 bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-50 text-primary-500">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="mt-3 text-sm font-medium text-foreground-800">商务合作</h3>
                <p className="mt-1 text-xs text-foreground-500">
                  广告投放 · 版权合作 · 品牌联名
                </p>
                <p className="mt-2 text-sm text-primary-500 font-medium">
                  biz@chongchong.com
                </p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-50 text-accent-500">
                  <i className="ri-edit-line text-xl"></i>
                </div>
                <h3 className="mt-3 text-sm font-medium text-foreground-800">内容投稿</h3>
                <p className="mt-1 text-xs text-foreground-500">
                  漫画推荐 · 同人创作 · 读者来稿
                </p>
                <p className="mt-2 text-sm text-primary-500 font-medium">
                  submit@chongchong.com
                </p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-50 text-secondary-500">
                  <i className="ri-question-answer-line text-xl"></i>
                </div>
                <h3 className="mt-3 text-sm font-medium text-foreground-800">用户反馈</h3>
                <p className="mt-1 text-xs text-foreground-500">
                  使用问题 · 功能建议 · 错误报告
                </p>
                <p className="mt-2 text-sm text-primary-500 font-medium">
                  help@chongchong.com
                </p>
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-background-200/70 text-center">
              <p className="text-xs text-foreground-400">
                工作时间：周一至周五 9:00 - 18:00 · 我们会在24小时内回复您的邮件
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}